import { InjectionToken } from '@angular/core';
import { FirebaseOptions } from '@firebase/app';

export interface CommonEnvironment {
  production: boolean;
  env: string;
  baseUrl: string;
  firebaseAppName: string;
  firebaseOptions: FirebaseOptions;
  appTitle: string;
  apiRestEndpoint: string;
  facebookPageUrl: string;
  facebookPageUrlShort: string;
  mailContact: string;
  facebookMessengerLink: string;
  instagramDirectMessageLink: string;
  whatsAppLink: string;
  recaptchaV3SiteKey: string;
  apiRequestMaxResultsNumber: number;
  facebookAppId: string;
  facebookPageId: string;
  algoliaAppId: string;
  algoliaApiKey: string;
  featureFlipping: {
    thirdPartyAuthentication: boolean;
    contactFabButton: boolean;
    strapiUserSettings: boolean;
  };
}

export const ENVIRONMENT = new InjectionToken<CommonEnvironment>('ENVIRONMENT');
